module.exports = __webpack_public_path__ + "images/morning_coffee/supershare_email_header.jpg";